export default {
  allowedMobileOnly: true,
  overrideProportionalResize: true,
};
